
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 10"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_44910","data-name":"Group 44910","transform":"translate(-115 -332)"}},[_c('rect',{attrs:{"id":"Rectangle_15041","data-name":"Rectangle 15041","width":"10","height":"10","transform":"translate(115 332)","fill":"none"}}),_c('path',{attrs:{"id":"Path_30602","data-name":"Path 30602","d":"M2.939 4.565A1.964 1.964 0 114.9 6.529a1.964 1.964 0 01-1.961-1.964zm4.642 1.071a1.607 1.607 0 111.608 1.607 1.607 1.607 0 01-1.608-1.607zM1.5 10.3a3.393 3.393 0 016.786 0v.057H1.5V10.3zm7.5 0H11.397c.118-.058.1-.129.1-.26a2.321 2.321 0 00-3.313-2.2A4.089 4.089 0 019 10.3z","transform":"translate(113.5 330.399)","fill":"#727996"}})])])
          )
        }
      }
    